import AttendanceRouter from "@/views/driver/views/attendance/router/attendance.router.js";
import DriverDashboard from "@/views/driver/views/dashboard/router/dashboard.router.js"

import DriverMain from "@/views/driver/DriverMain.vue";

const routes = [
    {
        path: "/driver",
        name: "driver",
        redirect: { name: "driver-dashboard" },
        meta: { module: 11 },
        component: DriverMain,
        children: [
            ...AttendanceRouter,
            ...DriverDashboard,
        ],
    },
];

export default routes;